import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import { useState } from "react";

interface ApiKeyModalProps {
  show: boolean;
  onHide: () => void;
  apiKey: string;
  keyName: string;
}

export default function ApiKeyModal({ show, onHide, apiKey, keyName }: ApiKeyModalProps) {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(apiKey);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy API key:", err);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="text-white"
      contentClassName="background-color-light border-radius-4"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="text-white w-100">
          <h4 className="mb-0">API Key Created Successfully</h4>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="pt-3">
        {/* Security Warning */}
        <Container className="mb-4 p-3" style={{ backgroundColor: '#83030320', border: '1px solid #83030350', borderRadius: '8px' }}>
          <Row className="align-items-center">
            <Col xs="auto" className="pe-2">
              <div style={{ color: '#ff4444', fontSize: '24px' }}>⚠️</div>
            </Col>
            <Col>
              <div className="text-danger mb-2" style={{ fontWeight: '600' }}>
                Important Security Notice
              </div>
              <div className="text-color" style={{ fontSize: '14px', lineHeight: '1.4' }}>
                This API key will only be shown once. Please copy it now and store it securely.
                For security reasons, you won't be able to view it again.
              </div>
            </Col>
          </Row>
        </Container>

        {/* API Key Details */}
        <Container className="mb-4">
          <div className="mb-3">
            <label className="wind-form-label d-block mb-2">Key Name</label>
            <div className="text-color p-3 background-color border-radius-4" style={{ border: '1px solid #283654' }}>
              {keyName}
            </div>
          </div>

          <div className="mb-3">
            <label className="wind-form-label d-block mb-2">API Key</label>
            <div className="position-relative">
              <div
                className="text-color p-3 font-monospace background-color border-radius-4"
                style={{
                  border: '1px solid #283654',
                  fontSize: '14px',
                  wordBreak: 'break-all',
                  paddingRight: '120px'
                }}
              >
                {apiKey}
              </div>
              <Button
                variant={copied ? "success" : "outline-secondary"}
                size="sm"
                className="position-absolute end-0 top-50 translate-middle-y me-2"
                onClick={copyToClipboard}
                style={{ borderRadius: '4px' }}
              >
                {copied ? "✓ Copied" : "📋 Copy"}
              </Button>
            </div>
          </div>
        </Container>

        {/* Usage Instructions */}
        <Container className="p-3" style={{ backgroundColor: '#0ba4bf10', border: '1px solid #0ba4bf30', borderRadius: '8px' }}>
          <div className="mb-2" style={{ fontWeight: '600', color: '#0ba4bf' }}>
            How to use your API key:
          </div>
          <div className="text-color" style={{ fontSize: '14px', lineHeight: '1.5' }}>
            Include this key in the header with your API requests as follows:
            <div className="mt-2 p-2 font-monospace background-color border-radius-4" style={{ fontSize: '12px' }}>
              X-API-Key: {apiKey.substring(0, 16)}...
            </div>
          </div>
        </Container>
      </Modal.Body>

      <Modal.Footer className="border-0 pt-0">
        <Button
          variant="primary"
          onClick={onHide}
          className="wind-btn"
          style={{ minWidth: '100px' }}
        >
          I Have Saved My Key
        </Button>
      </Modal.Footer>
    </Modal>
  );
}